<h5 class="title mb-4 text-primary">{{'sessao_i'|translate}}</h5>
<div class="row g-4 mb-4">
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_1')}}</label>
            <div class="form-control-wrap">
                <input type="text" #mdc_1="ngModel" name="mdc_1" [(ngModel)]="mdcService.formData.mdc_1"
                    placeholder="{{'opcional'|translate}}" class="form-control">
            </div>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4" for="fw-vr-first-name">{{mdcService.getLabelByCode('mdc_2')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdc2options">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input" id="mdc_2_{{item.id}}" #mdc_2="ngModel"
                            [(ngModel)]="mdcService.formData.mdc_2" value="{{item.value}}" name="mdc_2"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                        <label class="custom-control-label" for="mdc_2_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-6">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_3')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <input type="number" (ngModelChange)="mdcService.onMD3Change()"
                    [attr.data-msg]="('idade_error_msg' | translate)" id="mdc_3" #mdc_3="ngModel" name="mdc_3"
                    [(ngModel)]="mdcService.formData.mdc_3" placeholder="{{'idade_placeholder'|translate}}"
                    class="form-control required" min="0" max="{{mdcService.ano_max}}" required>
                <span
                    *ngIf="mdcService.formData.mdc_3 && mdcService.formData.mdc_3 && !mdcService.idadeConfereComData()"
                    id="mdc_3_error_msg" class="text-danger ff-italic fs-11px">{{'idade_error_msg'|translate}}</span>
            </div>
        </div>
    </div>
    <div class="col-lg-6">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_4')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <input type="date" id="MDC-4" [attr.data-msg]="('obrigatorio_error_msg' | translate)" id="mdc_4"
                    #mdc_4="ngModel" name="mdc_4" [(ngModel)]="mdcService.formData.mdc_4"
                    (ngModelChange)="mdcService.onMD4Change($event)" placeholder="{{'date_placeholder'|translate}}"
                    class="form-control" required pattern="\d{4}-\d{2}-\d{2}">
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_5'], mdcService.formData.mdc_3! >= 12, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_5')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_5="ngModel" name="mdc_5" [(ngModel)]="mdcService.formData.mdc_5"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" data-placeholder="Estado Civil" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc5options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_6')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select #mdc_6="ngModel" name="mdc_6" [(ngModel)]="mdcService.formData.mdc_6" class="form-select "
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" name="MDC-6"
                    data-placeholder="Nacionalidade" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc6options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_6_1'], mdcService.formData.mdc_6! > 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_6_1')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <ng-select #mdc_6_1="ngModel" name="mdc_6_1" id="mdc_6_1" [(ngModel)]="mdcService.formData.mdc_6_1"
                    [items]="paisService.listPaisEstrangeiros" bindLabel="name" bindValue="id"
                    placeholder="{{'selct_msg'|translate}}" required>
                </ng-select>
                <span id="mdc_6_1_error_msg" *ngIf="mdcService.formData.mdc_6_1! <= 0"
                    class="text-danger ff-italic fs-11px">{{'pais_nac_error_msg'|translate}}</span>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_7'], mdcService.formData.mdc_6! == 3, null)">
        <div class="form-group">
            <label class="form-label mb-4" for="fw-vr-first-name">{{mdcService.getLabelByCode('mdc_7')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdc7options">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input" id="mdc_7_{{item.id}}" #mdc_7="ngModel"
                            name="mdc_7" [(ngModel)]="mdcService.formData.mdc_7" value="{{item.value}}"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                        <label class="custom-control-label" for="mdc_7_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4"> {{mdcService.getLabelByCode('mdc_8')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdc8options">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input required" id="mdc_8_{{item.id}}"
                            #mdc_8="ngModel" name="mdc_8" [(ngModel)]="mdcService.formData.mdc_8" value="{{item.value}}"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" (change)="mdcService.onMDC8Change()"
                            required>
                        <label class="custom-control-label" for="mdc_8_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_9'], mdcService.formData.mdc_8! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_9')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <input type="number" [attr.data-msg]="('inconsistent_value' | translate)" #mdc_9="ngModel" name="mdc_9"
                    [(ngModel)]="mdcService.formData.mdc_9" placeholder="{{'year_placeholder'|translate}}" maxlength="4"
                    [attr.min]="mdcService.mdc9_ano_minimo" max="2025" class="form-control required" required>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_10'], mdcService.formData.mdc_8! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4" for="fw-vr-first-name">{{mdcService.getLabelByCode('mdc_10')}}
                {{mdcService.selectedPais | uppercase}}?<span class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <div class="input-group">
                    <div *ngFor="let item of mdcService.mdc10options"
                        class="custom-control custom-radio custom-control-pro no-control me-1">
                        <input type="radio" class="custom-control-input required" id="mdc_10_{{item.id}}"
                            #mdc_10="ngModel" name="mdc_10" [(ngModel)]="mdcService.formData.mdc_10"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" value="{{item.value}}" required>
                        <label class="custom-control-label" for="mdc_10_{{item.id}}">{{item.name}}</label>
                    </div>
                    <input type="number" placeholder="{{'year_month_placeholder'|translate}}" class="form-control"
                        #mdc_10_mes_ano="ngModel" name="mdc_10_mes_ano" [(ngModel)]="mdcService.formData.mdc_10_mes_ano"
                        [attr.data-msg]="('inconsistent_value' | translate)" min="1"
                        [max]="mdcService.formData.mdc_10 == 1 ? 12 : mdcService.formData.mdc_9 ? mdcService.ano_atual - mdcService.formData.mdc_9 : mdcService.ano_max"
                        required>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-12"
        *ngIf="mdcService.isVisibleCheckBox(['mdc_11'], mdcService.formData.mdc_8! == 1, null, mdcService.mdc11options)">
        <div class="form-group">
            <label class="form-label mb-4" for="fw-vr-first-name">{{mdcService.getLabelByCode('mdc_11')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center">
                <li *ngFor="let opcao of mdcService.mdc11options">
                    <div class="custom-control custom-control-sm custom-checkbox custom-control-pro">
                        <input type="checkbox" class="custom-control-input" [value]="opcao.id"
                            [id]="'mdc_11_' + opcao.id" name="mdc_11"
                            [attr.data-msg]="('obrigatorio_error_msg' | translate)" required
                            [(ngModel)]="opcao.isSelected"
                            (ngModelChange)="mdcService.onCheckboxChange(opcao, 'mdc_11', 'mdc_11_outro', 7)">
                        <label class="custom-control-label" [for]="'mdc_11_' + opcao.id">
                            {{ opcao.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12"
        *ngIf="mdcService.isVisible(['mdc_11_outro'], mdcService.formData.mdc_8! == 1 && this.mdcService.formData.mdc_11 && this.mdcService.formData.mdc_11.includes(7), null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_11_outro="ngModel" name="mdc_11_outro"
                [(ngModel)]="mdcService.formData.mdc_11_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
    <!-- *ngIf="mdcService.isVisible(['mdc_12_1','mdc_12_2','mdc_12_3'], mdcService.formData.mdc_8! == 1, null)" -->
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_12')}}</label>
            <div class="row g-3 mt-2">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_12_1')}}<span
                                class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_12_1_{{item.id}}"
                                    value="{{item.value}}" name="mdc_12_1" [(ngModel)]="mdcService.formData['mdc_12_1']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_12_1_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row g-3 mt-2"
                *ngIf="mdcService.isVisible(['mdc_12_2'], mdcService.formData.mdc_12_1! == 2, null)">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_12_2')}}<span
                                class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_12_2_{{item.id}}"
                                    value="{{item.value}}" name="mdc_12_2" [(ngModel)]="mdcService.formData['mdc_12_2']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_12_2_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row g-3 mt-2"
                *ngIf="mdcService.isVisible(['mdc_12_3'], mdcService.formData.mdc_12_2! == 2, null)">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_12_3')}}<span
                                class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_12_3_{{item.id}}"
                                    value="{{item.value}}" name="mdc_12_3" [(ngModel)]="mdcService.formData['mdc_12_3']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_12_3_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-12"
        *ngIf="mdcService.isVisible(['mdc_13'], mdcService.formData.mdc_8! == 1 && (mdcService.formData.mdc_12_1 == 1 || mdcService.formData.mdc_12_2 == 1), null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_13')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_13="ngModel" name="mdc_13" [(ngModel)]="mdcService.formData.mdc_13"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc13options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12"
        *ngIf="mdcService.isVisible(['mdc_14'], mdcService.formData.mdc_8! == 1 && (mdcService.formData.mdc_13! <= 2 && mdcService.formData.mdc_13! >= 1), null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_14')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <textarea class="form-control form-control-sm" rows="2" #mdc_14="ngModel" name="mdc_14"
                    [(ngModel)]="mdcService.formData.mdc_14" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                    required></textarea>
            </div>
        </div>
    </div>
    <!-- || (mdcService.formData.mdc_8! == 1 && mdcService.formData.mdc_12_1! == 2) -->
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_15'], mdcService.formData.mdc_8! == 2, null)">
        <div class="form-group">
            <label class="form-label mb-4" for="fv-phone">{{mdcService.getLabelByCode('mdc_15')}}<span
                    class="text-danger">&nbsp;*</span></label>

            <button type="button" class="btn btn-round btn-icon btn-sm btn-info btn-dim btn-outline-primary ms-2"
                [ngbPopover]="('generation_description' | translate)" [popoverTitle]="('generation_title' | translate)">
               <em class="icon ni ni-info"></em>
            </button>

            <div class="form-control-wrap">
                <ul class="custom-control-group">
                    <li *ngFor="let item of mdcService.mdc15options">
                        <div class="custom-control custom-radio custom-control-pro no-control">
                            <input type="radio" class="custom-control-input required" id="mdc_15_{{item.id}}"
                                #mdc_15="ngModel" name="mdc_15" [(ngModel)]="mdcService.formData.mdc_15"
                                [attr.data-msg]="('obrigatorio_error_msg' | translate)" value="{{item.value}}" required>
                            <label class="custom-control-label" for="mdc_15_{{item.id}}">{{item.name}}</label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4" for="fv-phone">{{mdcService.getLabelByCode('mdc_16')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <ul class="custom-control-group">
                    <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                        <div class="custom-control custom-radio custom-control-pro no-control">
                            <input type="radio" class="custom-control-input required" id="mdc_16_{{item.id}}"
                                #mdc_16="ngModel" name="mdc_16" [(ngModel)]="mdcService.formData.mdc_16"
                                [attr.data-msg]="('obrigatorio_error_msg' | translate)" value="{{item.value}}" required>
                            <label class="custom-control-label" for="mdc_16_{{item.id}}">{{item.name}}</label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>